import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAOL1S3mHz7eiYvX9UJTo1UpcpCwRzaKSw",
  authDomain: "thehaveidea.firebaseapp.com",
  projectId: "thehaveidea",
  storageBucket: "thehaveidea.firebasestorage.app",
  messagingSenderId: "1019948590188",
  appId: "1:1019948590188:web:5837978687d8bfbfa46449",
  measurementId: "G-2EM2LPV4SL"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;